export default __webpack_public_path__ + "7c8f2621ed84ca86f6a1e8f739ecf109.svg";